import { Button, Dialog, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';

interface AssetIssueFormProps {
  state: string;
  onClickCreateIssue: (assetID: number, data: { issueType: string; issueSeverity: string; note: string; detail: string }) => void;
  assetId: number;
}

const allowedIssueTypes = {
  ISSUE: 'ISSUE',
  WARNING: 'WARNING',
  CAUTION: 'CAUTION'
};
const allowedIssueSeverity = {
  URGENT: 'URGENT',
  NONURGENT: 'NONURGENT',
};

const AssetIssueForm = React.forwardRef((props: AssetIssueFormProps, ref) => {
  const [openStateModal, setOpenStateModal] = useState(false);
  const handleOpenModal = () => {
    setOpenStateModal(true);
  };
  const handleCloseModal = () => setOpenStateModal(false);
  const [issueType, setIssueType] = useState('');
  const [issueSeverity, setIssueSeverity] = useState('');
  const [detail, setDetail] = useState('');
  const [note, setNote] = useState('');

  function onCreateButtonClicked() {
    props.onClickCreateIssue(props.assetId, {
      issueType,
      issueSeverity,
      note,
      detail,
    });
    handleCloseModal();
  }

  return (
    <>
      <Button onClick={handleOpenModal} color="secondary" size="small" variant="contained">New Issue</Button>
      <Dialog
        onClose={handleCloseModal}
        open={openStateModal}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
        PaperProps={{
          style: {
            margin: '10px 0px',
            width: '100%',
            maxWidth: 500,
          },
        }}
        classes={{ scrollPaper: 'align-content-normal align-items-normal' }}
        style={{ height: '90%', maxHeight: 700, margin: 0 }}
      >
        <DialogTitle>New Issue</DialogTitle>
        <div style={{ padding: 12 }}>
          <FormControl fullWidth margin="normal">
            <InputLabel id="issue-type-select-label">Issue Type</InputLabel>
            <Select
              labelId="issue-type-select-label"
              value={issueType}
              label="Issue Type"
              onChange={e => setIssueType(e.target.value)}
            >
              {Object.keys(allowedIssueTypes).map(stateName => (
                <MenuItem key={`${props.assetId}-${stateName}`} value={stateName}>
                  {allowedIssueTypes[stateName]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel id="issue-severity-select-label">Issue Severity</InputLabel>
            <Select
              labelId="issue-severity-select-label"
              value={issueSeverity}
              label="Issue Severity"
              onChange={e => setIssueSeverity(e.target.value)}
            >
              {Object.keys(allowedIssueSeverity).map(severity => (
                <MenuItem key={`${props.assetId}-${severity}`} value={severity}>
                  {allowedIssueSeverity[severity]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              style={{ marginTop: 6 }}
              label="Title"
              variant="standard"
              value={note}
              onChange={e => setNote(e.target.value)}
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              style={{ marginTop: 6 }}
              label="Description"
              variant="standard"
              value={detail}
              onChange={e => setDetail(e.target.value)}
            />
          </FormControl>
        </div>
        <div style={{ padding: 12 }}>
          <Button onClick={onCreateButtonClicked} color="secondary" size="small" variant="contained">
            Create
          </Button>
        </div>
      </Dialog>
    </>
  );
});

export default AssetIssueForm;
